import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  trackProjectFilterApplied,
  deriveProjectType,
} from '@src/services/moengage';

// Fills project identity from redux so toolbars only pass the filter itself
const useTrackProjectFilterApplied = () => {
  const product = useSelector((state) => state.project.product);
  const source = useSelector((state) => state.project.source);

  return useCallback(
    ({ filterType, filterValue }) =>
      trackProjectFilterApplied({
        projectType: deriveProjectType({ product, source }),
        filterType,
        filterValue,
      }),
    [product, source],
  );
};

export default useTrackProjectFilterApplied;
